import { useState } from 'react';
import { ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from '@material-ui/core';
import { TitleDivider } from '../../loanEconomics/components/titleDivider';
import { QuoteDataTable } from './quotaDataTable';
import { observer } from 'mobx-react';

interface QuoteSummaryAccordionProps {
  store: any;
  title: string;
  data: {
    label: string,
    value: string
  }[]
}
const useStyles = makeStyles(theme => ({
  accordionSummary: {
    padding: 0,
    margin: 0,
    minHeight: 'unset !important',
    '&.Mui-expanded': {
      minHeight: 'unset',
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      '&.Mui-expanded': {
        margin: 0,
      },
    },
    '& .MuiAccordionSummary-expandIcon': {
      color: theme.palette.primary.main,
    }
  },
  accordion: {
    marginTop: '-14px',
  },
  accordionDetails: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: '-8px', // Adjust as needed
  },
  dividerClassName: {
    color: theme.palette.primary.main,
  },
}));

export const QuoteSummaryAccordion = observer(
  ({ store, title, data }: QuoteSummaryAccordionProps) => {
    const [expanded, setExpanded] = useState(true);
    const classes = useStyles();

    return (
      <Accordion
        expanded={expanded}
        onChange={(e, expanded) => setExpanded(expanded)}
        elevation={0}
        className={classes.accordion}
      >
        <AccordionSummary
          expandIcon={<ExpandMore fontSize="large" />}
          aria-controls="broker-accordion"
          className={classes.accordionSummary}
        >
          <TitleDivider hasItems title={title} dividerClassName={classes.dividerClassName} />
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails} style={{ display: 'block', marginTop: '-20px' }}>
          <QuoteDataTable rows={data} />
        </AccordionDetails>
      </Accordion>
    );
  }
);
